/**
 * 后台页面表：菜单「路由名称」必须在此登记才会挂 Vue 页。
 * component 必须是字面量 `() => import("../views/....vue")`，不能写路径字符串。
 */
import { registerRoutePages, type RoutePageConfig } from "@shared/router/routePageExtras";

const pages: Record<string, RoutePageConfig> = {
    Dashboard: { component: () => import("../views/dashboard/index.vue") },
    ProductGoods: { component: () => import("../views/product/goods/index.vue") },
    ProductLabel: { component: () => import("../views/product/label/index.vue") },
    SystemPermission: { component: () => import("../views/system/permission/index.vue") },
    SystemSystemRole: { component: () => import("../views/system/systemRole/index.vue") },
    SystemUser: { component: () => import("../views/system/user/index.vue") },
    SystemAccountUser: { component: () => import("../views/system/accountUser/index.vue") },
    SystemAccountRole: { component: () => import("../views/system/accountRole/index.vue") },
    SystemCorpCode: { component: () => import("../views/system/corpCode/index.vue") },
    SystemPersonalCenter: { component: () => import("../views/system/personalCenter/index.vue") },
    SystemBanner: { component: () => import("../views/system/banner/index.vue") },
    SystemAnnouncement: { component: () => import("../views/inSiteMessage/announcement/list/index.vue") },
    SystemAnnouncementEdit: { component: () => import("../views/inSiteMessage/announcement/edit/index.vue") },
    WorkOrderList: { component: () => import("../views/workOrder/list/index.vue") },
    WorkOrderTemplate: { component: () => import("../views/workOrder/template/index.vue") },
    StoreAmazonVc: { component: () => import("../views/store/amazonVc/index.vue") },
    StoreAmazonAd: { component: () => import("../views/store/amazonAd/index.vue") },
    StoreWalmartDsv: { component: () => import("../views/store/walmartDsv/index.vue") },
};

registerRoutePages(pages);

export { pages as routePages };
